export default function capitalizeFirstLetter(string: string): string {
    return string[0].toUpperCase() + string.slice(1);
}